import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import RootSwitch from './RootSwitch';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RootSwitch />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 2000,
          style: {
            background: '#111827',
            color: '#fff',
          },
        }}
      />
    </HelmetProvider>
  </React.StrictMode>
);
